import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { copyOrderRule } from '@/api/order';
export default {
  name: 'AddRemarkDialog',
  props: {},
  data: function data() {
    return {
      copyOrderRuleDialog: false,
      formOrder: {
        from_order_id: ''
      },
      order_id: ''
    };
  },
  watch: {
    copyOrderRuleDialog: function copyOrderRuleDialog(val) {
      if (!val) {
        this.remarks = '';
      }
    }
  },
  methods: {
    saveCopyOrderRule: function saveCopyOrderRule() {
      var _this = this;
      this.$refs.formOrder.validate(function (valid) {
        if (valid) {
          var params = {
            from_order_id: _this.formOrder.from_order_id,
            order_id: _this.order_id
          };
          copyOrderRule(params).then(function (res) {
            _this.$message.success('提交成功');
            _this.$emit('refreshOrderRule');
            _this.copyOrderRuleDialog = false;
          }).finally(function () {
            _this.formOrder.from_order_id = '';
          });
        }
      });
    }
  }
};